module.exports = __webpack_public_path__ + "img/gas01.30b051dd.gif";